import { FallbackLngObjList } from 'i18next';

interface EnvConfig {
  environment: string;
  inContext: { escapeUrl: string };
  langFallBack: FallbackLngObjList;
  langWhiteList: string[];
  logLevel: string;
  lslApi: string;
  mock: boolean;
  production: boolean;
}

export const _config = {} as EnvConfig;

export const getConfig = (): Promise<EnvConfig> => {
  const options = {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
    },
  };

  return new Promise<EnvConfig>((resolve, reject) => {
    fetch('/config.json', options)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        throw new Error('status was not OK');
      })
      .then((data: EnvConfig) => {
        Object.assign(_config, data);
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
